module.exports = __webpack_public_path__ + "img/lanqiu.1288ea53.png";